// Função para copiar o HTML formatado para a área de transferência
import htmlModule from 'html';

// var htmlmodule = require('html');
// var str = ' \n <div id="a">\n <span class="b"><span>Hello</span></span><input type="text">\n  \n</div>\n ';
// var pretty = htmlmodule.prettyPrint(str);

const createHiddenInput = (form, name, value = true, type = 'hidden') => {
  const input = document.createElement('input');
  input.name = name;
  input.value = value;
  input.type = type;
  form.appendChild(input);
};

const getDocumentHtml = () => {
  const htmlCode = document.cloneNode(true);

  htmlCode.querySelectorAll('head style').forEach((el) => el.remove());

  return htmlModule.prettyPrint(
    new XMLSerializer().serializeToString(htmlCode),
  );
};

export const copyDocumentHtmlToClipboard = () => {
  const html = getDocumentHtml();
  if (navigator.clipboard) {
    navigator.clipboard.writeText(html);
  }
};

const asesValidator = (content) => {
  // console.log(document.body.outerHTML);

  const form = document.createElement('form');

  form.name = 'form3';
  form.action = 'https://asesweb.governoeletronico.gov.br/avaliar-codigo';
  form.method = 'post';
  form.enctype = 'multipart/form-data';
  form.target = '_blank';
  form.style = 'display:none !important';

  ['mark', 'content', 'presentation', 'multimedia', 'form', 'behavior'].forEach(
    (name) => createHiddenInput(form, name),
  );

  const htmlInput = document.createElement('textarea');
  htmlInput.name = 'html';
  htmlInput.value = getDocumentHtml();
  form.appendChild(htmlInput);

  document.body.appendChild(form);

  form.submit();
  form.remove();
};

export default asesValidator;
